import React, { Fragment } from 'react';
import { Paper, Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useStyles } from "./styles";
import { useTranslation } from 'react-i18next';

export const GraphicPanel = ({ children }) => {
  const { chart, loading } = useSelector(state => state.report)
  const classes = useStyles();
  const { t } = useTranslation();
  
  return (
    <Fragment>
      { loading ? (
        <Paper className={classes.noContent} elevation={0}>
          <Box display="flex" justifyContent="center" alignItems="center">
            {t('carregando_informacoes')}
          </Box>
        </Paper>
      ) : (
        <Fragment>
          { chart.length > 0 ? (
            <Paper className={classes.paperContent}>
            { children }
            </Paper>
            ) : (
            <Paper className={classes.noContent} elevation={0}>
              <Box display="flex" justifyContent="center" alignItems="center">
                {t('nenhuma_ideia_encontrada')}. {' '} 
                {t('utilize_os_filtros_para_que_os_dados_sejam_carregados')}.
              </Box>
            </Paper>
          )}
        </Fragment>
      )}
    </Fragment>
  )
}
